import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./ViewPlanSubscription.scss";
import ControlPanelHeader from "../../components/ControlPanelHeader";
import { Box, Divider, Grid, MenuItem, Paper, Select, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getPlan, planList } from "../../../services/PlanService";
import Loader from "../../../components/Loader";
import { ArrowBack, ArrowBackIos, ArrowBackSharp } from "@material-ui/icons";
import EditFeaturesDialog from "../../components/EditFeaturesDialog";
import CommonUtil from "../../../util/CommonUtils";
import { toast } from "sonner";
import EditBillingInfo from "./EditBillingInfo";
import EditAccountInfo from "./EditAccountInfo";


export default function ViewPlanSubscription() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const { id: initialPlanName } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [dashboard, setDashboard] = useState("All Options");
  const [timesheet, setTimesheet] = useState("All Options");
  const [report, setReport] = useState("View");
  const [integration, setIntegration] = useState("Outlook, Teams");
  const [plan, setPlan] = useState({});
  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState(null);
  const [openEditFeature, setOpenEditFeature] = useState(false);
  const [monthlyCode, setMonthlyCode] = useState("")
  const [yearlyCode, setYearlyCode] = useState("")
  const [openEditBilling, setOpenEditBilling] = useState(false);
  const [openEditAccount, setOpenEditAccount] = useState(false);
  const [currentPlanName, setCurrentPlanName] = useState(initialPlanName);

  useEffect(() => {
    loadPlans();
  }, [currentPlanName]);

  useEffect(() => {
    if (!CommonUtil.isEmpty(plans)) {
      plans?.forEach(pl => {
        if (pl.intervalUnit == "months") {
          setMonthlyCode(pl.planCode);
        }
        if (pl.intervalUnit == "years")
          setYearlyCode(pl.planCode)
      })
    }
  }, [plans])

  const extractFeatureDetails = (data) => {
    return data?.featureDetails?.map((item) => ({
      label: item.feature.name,
      code: item.feature.code,
      fieldType: item.feature.fieldType,
      prefix: item.feature.inputPrefix || "",
      options: item.feature.fieldOptions || "",
      value: item.value
    }));
  };

  const getfeature = (code) => {
    if (!features)
      return;
    return features.find((feature) => feature.code === code);
  }

  const loadPlans = () => {
    getPlan(currentPlanName)
      .then((res) => {
        if (res?.status === 200 && res?.data?.code === "RCI0000") {
          setPlans(res.data.data.plansDetails);
          setPlan(res.data.data.plansDetails[0]);
          setFeatures(extractFeatureDetails(res.data.data));
          setRows(res.data.data);
        } else {
          setRows([]);
         if(res?.data?.code === "RCE0246") navigate("/plans")
        }
        setIsLoading(false);
      });
  }

  const handleEditFeatureSubmit = (res) => {
    setOpenEditFeature(false);
    setTimeout(() => {
      if (res.code == "RCI0042") {
        loadPlans();
        toast.success(res.message);
      }
      else
        toast.error(res.message);
    }, 500)
  }

  const handleBillingInfoUpdate = () => {
    loadPlans();
    setOpenEditBilling(false);
  };

  const handleAccountInfoUpdate = (updatedPlan) => {
    setPlan(updatedPlan); 
    setCurrentPlanName(updatedPlan.planOrder);
    loadPlans();
    setOpenEditAccount(false);
  };

  return (
    <div style={{ width: '100%' }}>


      {isLoading && <Loader open={isLoading} />}
      <Box mt={3}>{""}</Box>

      {!isLoading && (
        <div className="scrollablecontainer">

          <Paper elevation={0} className="content-container">

            <Box sx={{ textAlign: "center", p: 2, }}>

              <Box gap={2} sx={{ display: "flex", alignItems: 'start', justifyContent: "space-between", mb: 0.1 }}>
                <Link to="/plans" sx={{ textDecoration: "none" }}>
                  <Typography sx={{ fontSize: 16, fontWeight: "bold", color: '#1D0B77', whiteSpace: 'nowrap' }}>
                    ← {t('RAL0784')}
                  </Typography>
                </Link>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h6" fontWeight="bold" sx={{ wordBreak: 'break-all',  color:"#242424 !important" }}>
                    {plan.name}
                    
                  </Typography>


                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexWrap: 'nowrap',
                      gap: 1,
                      mt: 0.5
                    }}
                  >

                    <Box width={150}>
                      <Typography variant="body2" color="#242424" sx={{ whiteSpace: 'nowrap', textAlign: 'end' }}>
                        {/* {t('RAL0776')}: {plan.planOrder} */}
                        {"Sequence ID"}: {plan.planOrder}
                      </Typography>
                    </Box>

                    <Box width={10}>
                      <Typography
                        variant="body2"
                        color="#242424"
                        sx={{
                          whiteSpace: 'nowrap',
                          alignSelf: 'center',
                          textAlign: 'center',
                          minWidth: 10,
                        }}
                      >
                        {" | "}
                      </Typography>
                    </Box>

                    <Box width={150}>
                      <Typography variant="body2" color="#242424" sx={{ whiteSpace: 'nowrap' }}>
                        {/* {t('RAL0786')}: {plan.trailPeriod} {t('RAL0787')} */}
                        {"Free trial period"}: {plan.trailPeriod} {"Days"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {plans[0]?.planCode !=="0000" ? <Link href="#" sx={{ textDecoration: "none", fontSize: 14, fontWeight: "bold" }}>
                  <Typography sx={{ fontSize: 16, fontWeight: "bold", color: '#1D0B77', whiteSpace: 'nowrap' }} 
                  onClick={() => setOpenEditAccount(true)}>
                    {/* {t('RAL0785')} */}
                    Edit account details
                    </Typography>

                </Link>:<Box width={120}></Box>}
              </Box>
            </Box>

            <Divider sx={{ borderBottomWidth: 2, opacity: .5, borderColor: '#6A5FA2' }} />

            <Grid container spacing={2} mt={0.5} mb={1} justifyContent="space-evenly" alignItems="stretch">

              {/* Left Section */}
              <Grid item xs={12} md={5.9} sx={{ display: 'flex' }}>
                <Box sx={{
                  flexGrow: 1,
                  p: 3,
                  bgcolor: "#F5F5FA",
                  borderRadius: 2,
                }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" color="#242424">
                      {/* {t('RAL0788')} */}
                      Billing details
                      </Typography>
                    {plans[0]?.planCode !=="0000" && <Link href="#" sx={{ textDecoration: "none" }}>
                      <Typography sx={{ fontSize: 16, fontWeight: "bold", color: '#1D0B77' }}
                        onClick={() => setOpenEditBilling(true)}>
                        {/* {t('RAL0172')} */}
                        Edit
                      </Typography>
                    </Link>}
                  </Box>

                  <Divider sx={{ mb: 2 }} />

                  <Box>
                    {plans.map((plan, index) => (
                      <Box key={index} sx={{ mb: 15, mx: 0 }}>
                        <Grid container spacing={1} >
                          <Grid item xs={12} display={'flex'} >
                            <Grid item xs={6}>
                              <Typography variant="subtitle2" fontWeight="bold" color="#242424">
                                {/* {t('RAL0789')} */}
                                Plan ID
                                </Typography>
                            </Grid>
                            <Grid item xs={6} display="flex" gap={1}>
                              <Typography variant="subtitle2" fontWeight="bold"  color="#242424">{plan.planCode}</Typography>
                              <Typography variant="subtitle2" fontWeight="bold" color="#242424">-</Typography>
                              <Typography variant="subtitle2" fontWeight="bold" color="#242424">
                                {/* {plan.intervalUnit === 'months' ? t('RAL0792') : t('RAL0793')} */}
                                {plan.intervalUnit === 'months' ? 'Monthly' : "Yearly"}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} display={'flex'} >
                            <Grid xs={6}>
                              <Typography variant="subtitle2"  color="#242424">
                                {/* {t('RAL0790')} */}
                                Price
                                </Typography>
                            </Grid>
                            <Grid xs={6}>
                              <Typography variant="subtitle2"  color="#242424">{"$ " + plan.price}</Typography>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} display={'flex'} >
                            <Grid xs={6}>
                              <Typography variant="subtitle2"  color="#242424">
                                {/* {t('RAL0791')} */}
                                Plan description
                                </Typography>
                            </Grid>
                            <Grid xs={6}>
                              <Typography variant="subtitle2"  color="#242424" sx={{ maxWidth: "300px", wordWrap: "break-word" }}>{plan.description}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* {index !== plans.length - 1 && <Divider sx={{ mt: 2 }} />} */}
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Grid>

              {/* Right Section */}
              <Grid item xs={12} md={5.9} sx={{ display: 'flex' }}>
                <Box sx={{
                  flexGrow: 1,
                  p: 3,
                  bgcolor: "#F5F5FA",
                  borderRadius: 2,
                }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }} >
                    <Typography variant="subtitle1" fontWeight="bold"  color="#242424">
                      {/* {t('RAL0794')} */}
                      Feature details
                      </Typography>
                    <Link href="#" sx={{ textDecoration: "none" }}>
                      <Typography sx={{ fontSize: 16, fontWeight: "bold", color: '#1D0B77' }} onClick={() => setOpenEditFeature(true)}>
                        {/* {t('RAL0172')} */}
                        Edit
                      </Typography></Link>
                  </Box>

                  <Divider sx={{ mb: 2 }} />

                  <Grid container spacing={2} sx={{ mb: 1 }}>
                    {[
                      { code: "DASHBOARD" },
                      { code: "TIMESHEET" },
                      { code: "REPORT" },
                      { code: "INTEGRATION" },
                      { code: 'OTHERS' }
                    ].map((item, index) => (
                      features && getfeature(item.code) && (
                        <Grid item xs={12} key={index} display={'flex'} alignItems={'center'} gap={2}>
                          <Grid xs={4} sx={{ mt: 1.8 }}>
                            <Typography variant="subtitle2"  color="#242424">{getfeature(item.code).label}</Typography>
                          </Grid>
                          <Grid xs={8}>
                            <Select
                              variant="filled"
                              value={getfeature(item.code).value}
                              onChange={(e) => item.setValue(e.target.value)}
                              fullWidth
                              size="small"
                              disabled
                              sx={{
                                bgcolor: "white",
                                borderRadius: 1,
                                "& .MuiSelect-select": {
                                  textAlign: "left",
                                  paddingLeft: "0px",
                                  color: "#242424 !important",
                                  fontFamily: 'Gotham'
                                },
                                "& .Mui-disabled": {
                                  color: "#242424 !important",
                                  WebkitTextFillColor: "#242424 !important",
                                  opacity: 1,
                                },
                                "&::before": {
                                  borderBottom: "2px solid #D9D9D9 !important", // Changes the border color to a solid line
                                },
                                "&::after": {
                                  borderBottom: "2px solid #D9D9D9 !important", // Keeps border solid even when focused
                                },
                              }}
                            >
                              <MenuItem value={getfeature(item.code).value}>{getfeature(item.code).value}</MenuItem>

                            </Select>
                          </Grid>
                        </Grid>
                      )
                    ))}

                    {[
                      { code: 'PROJECT_COUNT' },
                      { code: 'MEMBER_COUNT' },
                      { code: 'TAG_COUNT' },
                      { code: 'DAILY_AI_SUMMARIZATION_LIMITS' },
                    ].map((item, index) => (
                      features && getfeature(item.code) && (
                        <Grid item xs={12} key={index} display={'flex'} alignItems={'center'} gap={2}>
                          <Grid xs={4}>
                            <Typography variant="subtitle2"  color="#242424">{getfeature(item.code).label}</Typography>
                          </Grid>
                          <Grid xs={8}>
                            <Typography variant="subtitle2" color="#242424">{getfeature(item.code).value}{" "}{getfeature(item.code).prefix}</Typography>
                          </Grid>

                        </Grid>)
                    ))}
                  </Grid >

                </Box>
              </Grid>
            </Grid>

          </Paper>
          <Box sx={{
            height: 50,
          
          }}>
          </Box>
        </div>
      )}

      {openEditFeature && <EditFeaturesDialog
        features={features}
        mCode={monthlyCode}
        yCode={yearlyCode}
        currentPlanOrder={plan.planOrder}
        open={openEditFeature}
        onClose={setOpenEditFeature}
        onSubmit={handleEditFeatureSubmit}
      />}

      {openEditBilling && <EditBillingInfo
        mCode={monthlyCode}
        yCode={yearlyCode}
        open={openEditBilling}
        onClose={setOpenEditBilling}
        onUpdate={handleBillingInfoUpdate}
        planName={currentPlanName}
      />}
      {openEditAccount && <EditAccountInfo
        mCode={monthlyCode}
        yCode={yearlyCode}
        open={openEditAccount}
        onClose={setOpenEditAccount}
        onUpdate={handleAccountInfoUpdate}
        planName={currentPlanName}
      />}
    </div>
  );
}